/**
 * Object with diamonds information and diamond utility methods
 *
 * @props
 * diamondsData: Object
 * diamondsMeta: Object
 */
var DiamondsMixin = {
  props: {
    diamondsData: {
      type: Object,
    },
    diamondsMeta: {
      type: Object,
    },
  },
  computed: {
    totalQueryDiamonds: function () {
      // console.log("diamondsMeta", this.diamondsMeta);
      return this.diamondsMeta ? this.diamondsMeta.total : 1000000;
    },
    enableLoadMore: function () {
      return this.diamondsMeta ? this.diamondsMeta.hasNext : true;
      //return this.totalQueryDiamonds > this.diamondsData.diamonds.length;
    },
  },
  methods: {
    isDiamondSelected: function (options, diamond) {
      return (
        options.find((option) => option.step.id === "diamond")?.choice.id ===
        diamond.id
      );
    },
  },
};
export default DiamondsMixin;
